// extracted by mini-css-extract-plugin
export default {"container":"L8-z","topReviewHeading":"M8-z","criticalReview":"N8-z","favorableReview":"O8-z","vsSeparator":"P8-z"};